/* Tüftlerei-Ratgeber: Harzmengen-Rechner
   Fluss auf die Platte malen oder auf einem eigenen Foto nachzeichnen (Maßstab über eine Maßlinie).
   Das Foto bleibt im Browser des Lesers, es wird nichts hochgeladen.
   Alle Texte kommen aus der Sektion (Theme-Editor, übersetzbar). */
(function () {
  'use strict';
  var RES = 2, PHOTO_MAX = 1400, YEL = '#ffd60a';

  function init(root) {
    if (!root || root.__trHz) return;
    root.__trHz = true;
    var q = function (n) { return root.querySelector('[data-el="' + n + '"]'); };
    var cfg = {};
    try { cfg = JSON.parse(q('cfg').textContent); } catch (e) { cfg = {}; }
    var T = cfg.t || {};
    var lang = document.documentElement.lang || 'de';
    var nf = function (v, d) { return v.toLocaleString(lang, { minimumFractionDigits: d, maximumFractionDigits: d }); };
    var num = function (v) { return parseFloat(String(v).replace(',', '.')); };
    var fill = function (s, o) { s = s || ''; for (var key in o) s = s.split('{' + key + '}').join(o[key]); return s; };

    var cv = q('cv'), ctx = cv.getContext('2d');
    var L = +q('L').value, B = +q('B').value, brush = 12, mode = 'paint', color = '#2457b8', alpha = 0.92, opa = 0.55;
    var px = 0, dirty = true, drawing = null, last = null, prevLine = null, alive = true;
    var photoC = null, line = null, lineCm = null;
    var mask = document.createElement('canvas'), mctx = mask.getContext('2d', { willReadFrequently: true });
    var tint = document.createElement('canvas'), tctx = tint.getContext('2d');

    function newMask(w, h, keep) {
      var m = document.createElement('canvas'); m.width = Math.max(1, Math.round(w)); m.height = Math.max(1, Math.round(h));
      var c = m.getContext('2d', { willReadFrequently: true });
      if (keep && mask.width) c.drawImage(mask, 0, 0, m.width, m.height);
      mask = m; mctx = c; tint.width = m.width; tint.height = m.height;
      cv.style.aspectRatio = m.width + ' / ' + m.height; dirty = true;
    }
    function setPlate(nl, nb, keep) { L = nl; B = nb; if (!photoC) newMask(nl * RES, nb * RES, keep); }
    function lineLen() { return line ? Math.hypot(line.x2 - line.x1, line.y2 - line.y1) : 0; }
    function cmPerPx() { if (!photoC) return 1 / RES; var d = lineLen(); return (lineCm > 0 && d > 2) ? lineCm / d : null; }
    function brushPx() { var c = cmPerPx(); return c ? brush / c : brush * mask.width / 200; }

    function band(pts, wf) {
      mctx.save(); mctx.lineCap = 'round'; mctx.strokeStyle = '#000';
      for (var j = 1; j < pts.length; j++) {
        mctx.lineWidth = Math.max(1, wf(j / pts.length)) * RES;
        mctx.beginPath(); mctx.moveTo(pts[j - 1][0] * RES, pts[j - 1][1] * RES); mctx.lineTo(pts[j][0] * RES, pts[j][1] * RES); mctx.stroke();
      }
      mctx.restore();
    }
    function preset(kind) {
      mctx.clearRect(0, 0, mask.width, mask.height);
      var N = 140, xs = function (j) { return -6 + (L + 12) * j / N; }, p, j;
      if (kind === 'bend') { p = []; for (j = 0; j <= N; j++) p.push([xs(j), B / 2 + B * 0.17 * Math.sin(j / N * Math.PI * 2.2 + 0.4)]); band(p, function (f) { return B * (0.17 + 0.07 * Math.sin(f * Math.PI * 3 + 1)); }); }
      if (kind === 'straight') { p = []; for (j = 0; j <= N; j++) p.push([xs(j), B / 2 + B * 0.025 * Math.sin(j / N * Math.PI * 4)]); band(p, function (f) { return B * (0.15 + 0.025 * Math.sin(f * Math.PI * 5)); }); }
      if (kind === 'edges') { [0, B].forEach(function (y, ix) { var pp = []; for (var jj = 0; jj <= N; jj++) pp.push([xs(jj), y]); band(pp, function (f) { return B * (0.2 + 0.1 * Math.sin(f * Math.PI * (ix ? 3 : 2) + ix * 1.3)); }); }); }
      dirty = true;
    }
    function pos(e) {
      var r = cv.getBoundingClientRect();
      return [Math.max(0, Math.min(mask.width, (e.clientX - r.left) / r.width * mask.width)), Math.max(0, Math.min(mask.height, (e.clientY - r.top) / r.height * mask.height))];
    }
    function paint(a, b) {
      var bw = brushPx();
      mctx.save(); mctx.globalCompositeOperation = mode === 'erase' ? 'destination-out' : 'source-over';
      mctx.lineCap = 'round'; mctx.lineJoin = 'round'; mctx.strokeStyle = '#000'; mctx.fillStyle = '#000'; mctx.lineWidth = bw;
      if (a[0] === b[0] && a[1] === b[1]) { mctx.beginPath(); mctx.arc(a[0], a[1], bw / 2, 0, Math.PI * 2); mctx.fill(); }
      else { mctx.beginPath(); mctx.moveTo(a[0], a[1]); mctx.lineTo(b[0], b[1]); mctx.stroke(); }
      mctx.restore(); dirty = true;
    }
    function countArea() {
      var d = mctx.getImageData(0, 0, mask.width, mask.height).data, c = 0;
      for (var j = 3; j < d.length; j += 4) if (d[j] > 127) c++;
      px = c;
    }

    function drawLine(pw, phh, dpr) {
      var sx = pw / mask.width, sy = phh / mask.height, x1 = line.x1 * sx, y1 = line.y1 * sy, x2 = line.x2 * sx, y2 = line.y2 * sy;
      ctx.save(); ctx.lineCap = 'round';
      ctx.strokeStyle = 'rgba(0,0,0,.75)'; ctx.lineWidth = 5 * dpr; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      ctx.strokeStyle = YEL; ctx.lineWidth = 2.5 * dpr; ctx.setLineDash([10 * dpr, 6 * dpr]); ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke(); ctx.setLineDash([]);
      [[x1, y1], [x2, y2]].forEach(function (p) {
        ctx.beginPath(); ctx.arc(p[0], p[1], 8 * dpr, 0, Math.PI * 2); ctx.fillStyle = YEL; ctx.fill(); ctx.lineWidth = 2 * dpr; ctx.strokeStyle = '#000'; ctx.stroke();
        ctx.beginPath(); ctx.arc(p[0], p[1], 1.6 * dpr, 0, Math.PI * 2); ctx.fillStyle = '#000'; ctx.fill();
      });
      var t = lineCm > 0 ? nf(lineCm, lineCm % 1 ? 1 : 0) + ' cm' : (T.massEintragen || '');
      ctx.font = '500 ' + (13 * dpr) + 'px "TR Plex Mono", ui-monospace, monospace'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var tw = ctx.measureText(t).width, mx = Math.max(tw / 2 + 12 * dpr, Math.min(pw - tw / 2 - 12 * dpr, (x1 + x2) / 2)), my = Math.max(14 * dpr, (y1 + y2) / 2 - 20 * dpr);
      ctx.fillStyle = 'rgba(0,0,0,.78)'; ctx.fillRect(mx - tw / 2 - 8 * dpr, my - 11 * dpr, tw + 16 * dpr, 22 * dpr); ctx.fillStyle = YEL; ctx.fillText(t, mx, my);
      ctx.restore();
    }
    function render() {
      var dpr = Math.min(2, window.devicePixelRatio || 1), w = cv.clientWidth || 600, h = w * mask.height / mask.width;
      var pw = Math.round(w * dpr), phh = Math.round(h * dpr);
      if (cv.width !== pw || cv.height !== phh) { cv.width = pw; cv.height = phh; }
      var cs = getComputedStyle(root), wood = cs.getPropertyValue('--tr-wood').trim() || '#e6bb84', edge = cs.getPropertyValue('--tr-wood-edge').trim() || '#b98146';
      ctx.globalAlpha = 1; ctx.imageSmoothingEnabled = true;
      if (photoC) { ctx.drawImage(photoC, 0, 0, pw, phh); }
      else {
        ctx.fillStyle = wood; ctx.fillRect(0, 0, pw, phh);
        ctx.strokeStyle = edge; ctx.globalAlpha = 0.3; ctx.lineWidth = dpr;
        for (var qq = 1; qq < 10; qq++) {
          ctx.beginPath();
          for (var x = 0; x <= pw + 12 * dpr; x += 12 * dpr) { var y = phh * qq / 10 + Math.sin(x / (70 * dpr) + qq * 1.7) * 3 * dpr + Math.sin(x / (23 * dpr) + qq) * dpr; if (x) ctx.lineTo(x, y); else ctx.moveTo(x, y); }
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }
      tctx.globalCompositeOperation = 'source-over'; tctx.clearRect(0, 0, tint.width, tint.height); tctx.drawImage(mask, 0, 0);
      tctx.globalCompositeOperation = 'source-in'; tctx.fillStyle = color; tctx.fillRect(0, 0, tint.width, tint.height);
      ctx.globalAlpha = photoC ? opa : alpha; ctx.drawImage(tint, 0, 0, pw, phh); ctx.globalAlpha = 1;
      if (photoC && line) drawLine(pw, phh, dpr);
      if (px < 1 && !(photoC && mode === 'measure')) {
        ctx.font = (15 * dpr) + 'px "TR Plex Sans", system-ui, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        if (photoC) {
          var t = T.leerFoto || '', tw = ctx.measureText(t).width;
          if (t) { ctx.fillStyle = 'rgba(0,0,0,.62)'; ctx.fillRect(pw / 2 - tw / 2 - 10 * dpr, phh / 2 - 14 * dpr, tw + 20 * dpr, 28 * dpr); ctx.fillStyle = '#ffffff'; ctx.fillText(t, pw / 2, phh / 2); }
        } else { ctx.fillStyle = edge; ctx.fillText(T.leerMalen || '', pw / 2, phh / 2); }
      }
    }
    function setDash() { ['rkg', 'rarea', 'rvol', 'rp'].forEach(function (id) { q(id).textContent = '–'; }); }
    function hintRow(t) { var list = q('plist'); list.innerHTML = ''; var p = document.createElement('p'); p.className = 'tr-hint'; p.textContent = t || ''; list.appendChild(p); }
    function calc() {
      var Tm = +q('T').value, O = +q('O').value, Z = +q('Z').value, rho = +q('rho').value, mp = +q('mp').value;
      brush = +q('W').value;
      q('Lo').textContent = L + ' cm'; q('Bo').textContent = B + ' cm'; q('To').textContent = Tm + ' mm'; q('Oo').textContent = nf(O, 1) + ' mm';
      q('Zo').textContent = Z + ' %'; q('rhoo').textContent = nf(rho, 2) + ' kg/l'; q('mpo').textContent = mp + ' mm'; q('Wo').textContent = brush + ' cm';
      var c = cmPerPx();
      q('photo-size').textContent = (photoC && c) ? fill(T.fotoGroesse, { b: nf(mask.width * c, 0), h: nf(mask.height * c, 0) }) : '';
      if (!c) { setDash(); hintRow(T.brauchtMass); return; }
      var h = Tm + O, dm2 = px * c * c / 100, vol = dm2 * h / 100, kg = vol * rho * (1 + Z / 100);
      var pours = Math.max(1, Math.ceil(h / mp - 1e-9));
      q('rkg').textContent = nf(kg, 1) + ' kg';
      q('rarea').textContent = nf(dm2, 1) + ' dm²';
      q('rvol').textContent = nf(vol, 1) + ' l';
      q('rp').textContent = pours + ' ' + (pours === 1 ? (T.guss || '') : (T.guesse || ''));
      var a = num(q('ra').value), b = num(q('rb').value);
      var ok = a > 0 && b > 0 && isFinite(a) && isFinite(b);
      q('rerr').hidden = ok; q('ra').setAttribute('aria-invalid', String(!(a > 0))); q('rb').setAttribute('aria-invalid', String(!(b > 0)));
      if (!ok) { hintRow(T.verhaeltnisPruefen); return; }
      if (kg <= 0) { hintRow(photoC ? T.brauchtFlussFoto : T.brauchtFluss); return; }
      var list = q('plist'); list.innerHTML = '';
      var per = kg / pours, shareA = a / (a + b), rows = Math.min(pours, 6);
      for (var j = 0; j < rows; j++) {
        var row = document.createElement('div'); row.className = 'tr-pour';
        var lo = h / pours * j, hi = h / pours * (j + 1);
        var lvl = document.createElement('span'); lvl.className = 'tr-lvl';
        lvl.textContent = (pours === 1 ? (T.einGuss || '') : fill(T.nGuss, { n: j + 1 })) + ' · ' + nf(lo, 0) + '–' + nf(hi, 0) + ' mm';
        var mix = document.createElement('div'); mix.className = 'tr-mix';
        var sa = document.createElement('span'); sa.className = 'tr-mA'; sa.style.width = (shareA * 100) + '%'; sa.textContent = (T.harz || '') + ' ' + nf(per * shareA, 2) + ' kg';
        var sb = document.createElement('span'); sb.className = 'tr-mB'; sb.style.width = ((1 - shareA) * 100) + '%'; sb.textContent = (T.haerter || '') + ' ' + nf(per * (1 - shareA), 2) + ' kg';
        mix.appendChild(sa); mix.appendChild(sb); row.appendChild(lvl); row.appendChild(mix); list.appendChild(row);
      }
      if (pours > rows) { var pm = document.createElement('p'); pm.className = 'tr-hint'; pm.textContent = fill(T.weitere, { n: pours - rows }); list.appendChild(pm); }
      var tot = document.createElement('p'); tot.className = 'tr-hint'; tot.textContent = fill(T.gesamt, { a: nf(kg * shareA, 2), b: nf(kg * (1 - shareA), 2) }); list.appendChild(tot);
    }
    function loop() {
      if (!alive) return;
      if (!document.body.contains(root)) { alive = false; return; }
      if (dirty) { dirty = false; countArea(); render(); calc(); }
      requestAnimationFrame(loop);
    }

    cv.addEventListener('pointerdown', function (e) {
      try { cv.setPointerCapture(e.pointerId); } catch (_) {}
      var p = pos(e);
      if (mode === 'measure' && photoC) {
        var r = cv.getBoundingClientRect(), hit = 28 * mask.width / r.width;
        var d1 = line ? Math.hypot(p[0] - line.x1, p[1] - line.y1) : 1e9, d2 = line ? Math.hypot(p[0] - line.x2, p[1] - line.y2) : 1e9;
        if (d1 < hit && d1 <= d2) drawing = 'p1';
        else if (d2 < hit) drawing = 'p2';
        else { drawing = 'new'; prevLine = line; line = { x1: p[0], y1: p[1], x2: p[0], y2: p[1] }; }
        dirty = true; return;
      }
      drawing = 'paint'; last = p; paint(p, p); setPreset(null);
    });
    cv.addEventListener('pointermove', function (e) {
      if (!drawing) return;
      var p = pos(e);
      if (drawing === 'p1') { line.x1 = p[0]; line.y1 = p[1]; dirty = true; return; }
      if (drawing === 'p2' || drawing === 'new') { line.x2 = p[0]; line.y2 = p[1]; dirty = true; return; }
      paint(last, p); last = p;
    });
    function endDraw() { if (drawing === 'new' && lineLen() < 6) line = prevLine; drawing = null; dirty = true; }
    cv.addEventListener('pointerup', endDraw); cv.addEventListener('pointercancel', endDraw);

    var pres = Array.prototype.slice.call(root.querySelectorAll('[data-preset]'));
    function setPreset(k) { pres.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-preset') === k)); }); }
    pres.forEach(function (b) { b.addEventListener('click', function () { preset(b.getAttribute('data-preset')); setPreset(b.getAttribute('data-preset')); }); });
    q('clear').addEventListener('click', function () { mctx.clearRect(0, 0, mask.width, mask.height); setPreset(null); dirty = true; });
    function setMode(m) { mode = m; ['paint', 'erase', 'measure'].forEach(function (key) { q('m-' + key).setAttribute('aria-pressed', String(key === m)); }); dirty = true; }
    q('m-paint').addEventListener('click', function () { setMode('paint'); });
    q('m-erase').addEventListener('click', function () { setMode('erase'); });
    q('m-measure').addEventListener('click', function () { setMode('measure'); });
    var sws = Array.prototype.slice.call(root.querySelectorAll('.tr-sw'));
    sws.forEach(function (s) { s.addEventListener('click', function () { color = s.getAttribute('data-c'); alpha = +s.getAttribute('data-a'); sws.forEach(function (o) { o.setAttribute('aria-pressed', String(o === s)); }); dirty = true; }); });
    q('L').addEventListener('input', function () { setPlate(+q('L').value, B, true); });
    q('B').addEventListener('input', function () { setPlate(L, +q('B').value, true); });
    ['T', 'O', 'Z', 'rho', 'mp', 'W', 'ra', 'rb'].forEach(function (id) { q(id).addEventListener('input', function () { dirty = true; }); });
    q('OP').addEventListener('input', function () { opa = +q('OP').value / 100; q('OPo').textContent = q('OP').value + ' %'; dirty = true; });
    q('LC').addEventListener('input', function () {
      var raw = q('LC').value.trim(), v = num(raw);
      lineCm = (v > 0 && isFinite(v)) ? v : null;
      var bad = raw !== '' && lineCm === null; q('lc-err').hidden = !bad; q('LC').setAttribute('aria-invalid', String(bad)); dirty = true;
    });

    function photoUI(on) {
      q('measure').hidden = !on; q('m-measure').hidden = !on; q('presets').hidden = on; q('row-L').hidden = on; q('row-B').hidden = on;
      q('photo-note').hidden = !on; q('photo-rm').hidden = !on; q('opa-row').hidden = !on;
    }
    q('photo').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = ''; if (!f) return;
      var err = q('photo-err'); err.hidden = true;
      if (f.type && f.type.indexOf('image/') !== 0) { err.textContent = T.fehlerTyp || ''; err.hidden = false; return; }
      var url = URL.createObjectURL(f), img = new Image();
      img.onload = function () {
        var s = Math.min(1, 2400 / Math.max(img.naturalWidth, img.naturalHeight)), c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s); c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url); photoC = c;
        var k = Math.min(1, PHOTO_MAX / Math.max(c.width, c.height)); newMask(c.width * k, c.height * k, false);
        line = { x1: mask.width * 0.15, y1: mask.height * 0.5, x2: mask.width * 0.85, y2: mask.height * 0.5 };
        q('LC').value = ''; lineCm = null; q('lc-err').hidden = true; q('LC').setAttribute('aria-invalid', 'false');
        photoUI(true); setPreset(null); setMode('measure'); dirty = true;
        if (q('measure').scrollIntoView) q('measure').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      };
      img.onerror = function () { URL.revokeObjectURL(url); err.textContent = T.fehlerLaden || ''; err.hidden = false; };
      img.src = url;
    });
    q('photo-rm').addEventListener('click', function () {
      photoC = null; line = null; lineCm = null; photoUI(false); setMode('paint'); q('photo-err').hidden = true;
      newMask(L * RES, B * RES, false); preset('bend'); setPreset('bend');
    });
    if (window.ResizeObserver) new ResizeObserver(function () { dirty = true; }).observe(cv);
    if (window.matchMedia) { var mq = window.matchMedia('(prefers-color-scheme: dark)'); if (mq.addEventListener) mq.addEventListener('change', function () { dirty = true; }); }

    setPlate(L, B, false); preset('bend'); requestAnimationFrame(loop);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-tr-harz]');
    for (var j = 0; j < list.length; j++) init(list[j]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
